module.exports = __webpack_public_path__ + "img/DALIA.15bb5a2c.png";